export { default } from "./SwiftFactorChart";
